module.exports = __webpack_public_path__ + "img/load-verification-no.abc68fba.svg";